var waypoints = require('./_vendor/01.jquery.waypoints.js');
var countUp = require('./_vendor/02.jquery.countup.js');
var slick = require('./_vendor/03.slick.min.js');
var countUpFire = require('./modules/countup.js');
// var styleguide = require('./modules/style-guide.js');
// var cards = require('./modules/cards.js');
var accordions = require('./modules/accordions.js');
var bioButton = require('./modules/bioButton.js');
var menu = require('./modules/menu.js');
var menuSearch = require('./modules/menuSearch.js');
// var sliders = require('./modules/sliders.js');
var slider = require('./modules/slider.js');
var svg = require('./modules/svg.js');
// var preScreen = require("./modules/preScreen.js");
var fancyBox = require('./_vendor/jquery.fancybox.min');
var faqSearch = require('./modules/faq-search.js');
var parallax = require('./modules/parallax.js');
var headerScrollColor = require('./modules/headerScrollColor.js');
var forms = require('./modules/forms.js');
var headerBanner = require('./modules/headerBanner.js');

// Make sure that you init the styleguide first.
// styleguide.init();
// cards.init();
// test

accordions.init();
bioButton.init();
menu.init();
menuSearch.init();
// sliders.init();
slider.init();
svg.init();
countUpFire.init();
fancyBox.init();
// preScreen.init();
faqSearch.init();
parallax.init();
headerScrollColor.init();
forms.init();
headerBanner.init();
